import React from "react";
import "./descriptionPanel";
import dataPanel from "../../../service/dataPanel.json";
import CardBgnNone from "../../../utility/templete/cardbgnNone";
const DescriptionPanel = () => {
  return (
    <div>
      <div className="container">
        <div className="row ">
          {dataPanel.descriptionPanel.map((p) => (
            <CardBgnNone
              maxWidth={16}
              title={p.title}
              description={p.description}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default DescriptionPanel;
